export const BANK_ALIASES: Record<string, readonly string[]> = {
  LCL: ['credit lyonnais', 'le credit lyonnais', 'lyonnais'],
  'Crédit Mutuel de Bretagne': ['cmb', 'arkea', 'credit mutuel arkea', 'cm bretagne'],
  'Crédit Mutuel du Sud Ouest': ['cmso', 'cm sud ouest', 'cm sud-ouest'],
  BoursoBank: ['boursorama', 'boursorama banque', 'bourso'],
  'Hello bank!': ['hello bank', 'hellobank', 'hello banque'],
  'BNP Paribas': ['bnpp', 'bnp'],
  'Société Générale': ['socgen', 'soc gen'],
  BforBank: ['b for bank', 'bfor'],
  'Banque Européenne Crédit Mutuel': ['becm'],
};
